/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/// <reference types="jasmine" />

/**
 * @module
 * @description
 * Entry point for all public APIs of this package.
 */
export * from './src/testing';
